import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const CallToAction = () => {
  // Animation for button pulse
  const buttonVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: { repeat: Infinity, duration: 1.5 },
    },
  };

  return (
    <Box
      className="cta-section"
      sx={{
        py: 8,
        bgcolor: "primary.main",
        color: "background.paper",
        textAlign: "center",
        // background: "linear-gradient(45deg, #e63946, #2c3e50)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography variant="h2" gutterBottom>
          Join the Kitchen Revolution!
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 4, maxWidth: "600px", mx: "auto" }}
        >
          List your kitchen on AirKitchenz today and start earning passive
          income from your idle kitchen space.
        </Typography>
        <motion.div variants={buttonVariants} animate="pulse">
          <Button
            variant="contained"
            sx={{
              backgroundColor: "background.paper",
              color: "primary.main",
              "&:hover": { backgroundColor: "#e0e0e0" },
              px: 4,
              py: 1.5,
            }}
            href="/profile/add-kitchen"
          >
            Add Your Kitchen Now
          </Button>
        </motion.div>
      </motion.div>
    </Box>
  );
};

export default CallToAction;
